import React from 'react'
import { Link } from 'react-router-dom'
import Header from './header/Header'
import { Helmet } from 'react-helmet'
const ErrorPage = () => {
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Looking for the best deals travel packages? My Sitti Vacations offers the best & popular vacation packages, flight vacation deals, vacation discounts, and more."
                />
            </Helmet>
            <div style={{ textAlign: "center",display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div className='errorImg'></div>
                <h1 className='err-text'>
                    Requested page not available
                </h1>
            </div>
            <div style={{ display: "flex",justifyContent:"center",alignItems: "center", justifyContent: "space-around" }}>
                <Link to="/">
                    <button className='errorHome'>
                        Home
                    </button>
                </Link>
            </div>
        </>

    )
}

export default ErrorPage